import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38321572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modale-overlay" }
const _hoisted_2 = { class: "modale-card d-flex flex-column p-4" }
const _hoisted_3 = { class: "modale-text mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "modale-text mb-3"
}
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-check",
  viewBox: "0 0 16 16"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-check",
  viewBox: "0 0 16 16"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x",
  viewBox: "0 0 16 16"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { class: "btn btn-primary modale-button mx-2 disabled" }
const _hoisted_20 = {
  key: 5,
  class: "error-text mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_loader = _resolveComponent("the-loader")!
  const _component_navigation_recap = _resolveComponent("navigation-recap")!
  const _component_error_recap = _resolveComponent("error-recap")!
  const _component_the_dialog = _resolveComponent("the-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, "Version : " + _toDisplayString(_ctx.appVersion), 1),
      (_ctx.backendVersion !== '')
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, "Version Backend : " + _toDisplayString(_ctx.backendVersion), 1))
        : _createCommentVNode("", true),
      (_ctx.isResetDone !== 'non')
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            class: "modale-text mb-3 clickable",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayDetailsReset = !_ctx.displayDetailsReset))
          }, [
            _createTextVNode("Reset : " + _toDisplayString(_ctx.isResetDone) + " ", 1),
            (_ctx.isResetDone === 'Terminé')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
              : (_ctx.isResetDone === 'Terminé en erreur')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayDetailsReset)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.tabClearDone, (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.id,
              class: "item-done"
            }, [
              _createTextVNode(_toDisplayString(item.name) + " ", 1),
              (item.isClearDone)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                : (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.isResetDone !== 'En cours')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-primary modale-button mx-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmReset && _ctx.confirmReset(...args)))
            }, "Reset"),
            _createElementVNode("button", {
              class: "btn btn-primary modale-button mx-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validation && _ctx.validation(...args)))
            }, "OK")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("button", _hoisted_19, [
              _createVNode(_component_the_loader, { class: "loader-position" })
            ])
          ])),
      (_ctx.errorMessage !== '')
        ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_navigation_recap),
      _createVNode(_component_error_recap),
      (_ctx.isConfirmResetVisible)
        ? (_openBlock(), _createBlock(_component_the_dialog, {
            key: 6,
            message: 'Attention, toutes les données non sauvegardées seront perdues. Voulez-vous continuer ?',
            textButtonCancel: 'Non',
            textButtonValidation: 'Oui',
            onDialogclosecancel: _ctx.hideConfirmReset,
            onDialogclosevalid: _ctx.reset
          }, null, 8, ["message", "onDialogclosecancel", "onDialogclosevalid"]))
        : _createCommentVNode("", true)
    ])
  ]))
}